import { useState } from "react"
import { useDispatch } from "react-redux"
import { useTranslation } from "react-i18next"
import type { SelectChangeEvent } from "@mui/material/Select"
import Select from "@mui/material/Select"
import MenuItem from "@mui/material/MenuItem"
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded"

import { switchLanguage } from "features/store/configSlice"
import { LANGUAGE_KEYS } from "helpers/utils/constants"

export default function LanguageSelect() {
  const { i18n } = useTranslation()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)

  const handleLanguageChange = (event: SelectChangeEvent<string>) => {
    dispatch(switchLanguage(event.target.value))
    i18n.changeLanguage(event.target.value)
  }

  const userLanguage = i18n.resolvedLanguage

  return (
    <Select
      value={userLanguage}
      onChange={handleLanguageChange}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      variant="standard"
      disableUnderline
      IconComponent={(props) => (
        <KeyboardArrowDownRoundedIcon {...props} fontSize="small" />
      )}
      MenuProps={{
        PaperProps: {
          sx: {
            width: 65,
            mt: 1,
          },
        },
      }}
      sx={{
        "& .MuiSelect-select": {
          py: 0,
          "&:focus": {
            backgroundColor: "transparent",
          },
        },
      }}
    >
      {LANGUAGE_KEYS.map((key) => (
        <MenuItem key={key} value={key}>
          {key.toUpperCase()}
        </MenuItem>
      ))}
    </Select>
  )
}
